<!-- Full page overlay -->
<div class="spark-history-overlay" *ngIf="isVisible">
  <div class="gpd-full-page spark-history-container">
    <app-gpd-button
      icon="arrow-left-line"
      text="Back"
      type="text"
      color="var(--color-grey-500)"
      (onClick)="onCloseClick()"
    ></app-gpd-button>
    <dx-data-grid
      [dataSource]="logData"
      [columnAutoWidth]="true"
      class="gpd-datagrid"
      [showBorders]="true"
      [showColumnLines]="false"
      [showRowLines]="true"
      height="100%"
      width="100%"
    >
      <!-- User Name Column -->
      <dxi-column
        dataField="log"
        i18n-caption="@@log"
        caption="Log"
      ></dxi-column>

      <dxi-column
        dataField="previousValue"
        i18n-caption="@@previousValue"
        caption="Previous Value"
        cellTemplate="previousValueTemplate"
        width="30%"
      ></dxi-column>

      <!-- New Value Column -->
      <dxi-column
        dataField="newValue"
        i18n-caption="@@newValue"
        caption="New Value"
        cellTemplate="newValueTemplate"
        width="30%"
      ></dxi-column>

      <dxi-column
        dataField="dateChanged"
        i18n-caption="@@date"
        caption="Date"
        dataType="date"
        format="dd.MM.yyyy HH:mm"
      ></dxi-column>

      <dxi-column
        dataField="userName"
        i18n-caption="@@user"
        caption="User"
        cellTemplate="userNameTemplate"
      >
        <div *dxTemplate="let data of 'userNameTemplate'">
          <div class="user-name-cell">
            <div class="user-name">
              {{ (configService.userMap$ | async)[data.value] || data.value }}
            </div>
          </div>
        </div>
      </dxi-column>

      <!-- Previous Value Template -->
      <div *dxTemplate="let data of 'previousValueTemplate'">
        <div class="value-cell" [innerHTML]="data.value"></div>
      </div>

      <!-- New Value Template -->
      <div *dxTemplate="let data of 'newValueTemplate'">
        <div class="value-cell" [innerHTML]="data.value"></div>
      </div>
    </dx-data-grid>
  </div>
</div>
